import { useDispatch } from 'react-redux';
import { getCandidateById, getPartyById } from '../../selectors';
import React from 'react';
import { getTranslator } from '../../Translator';
import { vote } from '../../features/election/electionsSlice';
import { useAppSelector } from '../../hooks';

type ConfirmVoteProps = {
    candidateId: number;
    onCancel(): void;
}

export const ConfirmVote = (props: ConfirmVoteProps) => {
    const candidates = useAppSelector(state => state.candidates);
    const parties = useAppSelector(state => state.parties);
    const language = useAppSelector(state => state.language);
    const token = useAppSelector(state => state.clientState.RequestVerificationToken);

    const t = getTranslator(language);
    const dispatch = useDispatch();

    const candidate = getCandidateById(candidates, props.candidateId);
    const party = getPartyById(parties, candidate.PartyId);

    return <div className="statusbanner--ok">
        <br />
        <p>{t["Verify that you selected the right candidate and click 'Confirm vote'."]}</p>
        <div className="buttonrow">
            <button type="button" id="Candidate-ConfirmVote" className="button--important" onClick={() => vote(party.ElectionId, props.candidateId, token, dispatch)}>
                {t['Confirm vote']}
            </button>
            <button type="button" onClick={props.onCancel}>
                {t['Back']}
            </button>
        </div>
    </div>
}


